import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Istage } from '../../../../framework/Istage';
import { TranslateService } from '@ngx-translate/core';
import { UtilService } from '../../../util/UtilService';
import { FirebaseConstant } from '../../../constant/firebase.constant';
import { FirebaseAnalyticsService } from '../../../services/firebaseanalytics.service';
import { PageConstant } from 'src/app/constant/page.constant';

@Component({
    selector: 'app-fcbtutorialsmobile',
    templateUrl: './fcbtutorials.mobile.component.html',
    styleUrls: ['./fcbtutorials.mobile.component.scss'],
    standalone: false
})
export class FCBTutorialsMobileComponent implements OnInit {
  @HostListener('document:keydown', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    if (event.key.toLowerCase() == 'escape') {
      this.buttonClick('close');
    }
    if (
      event.key.toLowerCase() == 'arrowleft' ||
      event.key.toLowerCase() == 'uikeyinputleftarrow'
    ) {
      this.buttonClick('left');
    }
    if (
      event.key.toLowerCase() == 'arrowright' ||
      event.key.toLowerCase() == 'uikeyinputrightarrow'
    ) {
      this.buttonClick('right');
    }
  }

  @Input() layoutdata: Istage;
  @Input() helpContentStage: Istage = {
    stageWidth: 720,
    stageHeight: 529,
    stageLeft: 0,
    stageTop: 375,
    stageZ: 72,
    position: 'absolute',
    overflow: 'hidden',
  };
  @Input() helpCloseStage: Istage = {
    stageWidth: 55,
    stageHeight: 55,
    stageLeft: 655,
    stageTop: 402,
    stageZ: 73,
    position: 'absolute',
    overflow: 'hidden',
  };
  @Input() settingsContentStage: Istage = {
    stageWidth: 626,
    stageHeight: 370,
    stageLeft: 45,
    stageTop: 480,
    stageZ: 994,
    position: 'absolute',
    overflow: 'hidden',
  };
  @Input() overlayTutorialScreenDisplay: number;
  @Input() scaleR: any = {
    scale: 1,
    scaleX: 1,
    scaleY: 1,
    offsetLeft: 0,
    offsetTop: 0,
  };
  @Input() navKey: string;
  @Input() display: number = 1;
  @Input() isTutorialForHint = false;
  @Input() tutorialListForHint = [];
  @Input() isShowTutorial: string;
  @Input() language: string = 'en';
  @Input() tutorialCount: number = 0;

  @Output('modeClicked') modeClicked: EventEmitter<object> =
    new EventEmitter<object>();
  @Output('showQuickTutorial') showQuickTutorial: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  public quickTutorialCount: number = 0;
  public isLangShow: boolean = false;
  //public imgBackGround:string = "Tutorial_Background@2x.webp";
  public imgBackGround: string = 'quickTutorial_Background@2x.webp';
  public isShowQuickTutorial: boolean = false;

  public tutorialContent: Object = {
    TN_image_0: 'fcb_tutorials_01_Index@2x.webp',
    TN_image_1: 'fcb_tutorials_02_Full_Color_Cards@2x.webp',
    TN_image_2: 'fcb_tutorials_03_Scores@2x.webp',
    TN_image_3: 'fcb_tutorials_04_Ways_to_Win@2x.webp',
    TN_image_4: 'fcb_tutorials_05_Game_Rules@2x.webp',
    TN_image_5: 'fcb_tutorials_06_Hand_Scoring@2x.webp',
    TN_image_6: 'fcb_tutorials_07_Deal_Scoring@2x.webp',
    TN_image_7: 'fcb_tutorials_08_Draw_Scoring@2x.webp',
    TN_image_8: 'fcb_tutorials_09_Spread_Banker_Chases_Player@2x.webp',
    TN_image_9: 'fcb_tutorials_10_Spread_Player_Chases_Banker@2x.webp',
    TN_image_10: 'fcb_tutorials_11_Spread_Dual_Chase@2x.webp',
    TN_image_11: 'fcb_tutorials_12_Spread_Game_Over@2x.webp',
    TN_image_12: 'fcb_tutorials_13_Tie_Game_Rules@2x.webp',
    TN_image_13: 'fcb_tutorials_14_Commission_Rules@2x.webp',
    TN_image_14: 'fcb_tutorials_15_Side_Bets@2x.webp',
    TN_image_15: 'fcb_tutorials_16_Session_Bets@2x.webp',
    TN_image_16: 'fcb_tutorials_17_Live_Side_Bets@2x.webp',
    TN_image_17: 'fcb_tutorials_18_Raw_Scores_and_Hand_Ranks@2x.webp',
    TN_image_18: 'fcb_tutorials_19_Road_Maps@2x.webp',
    TN_image_19: 'fcb_tutorials_20_Quick_Keys@2x.webp',
    TN_image_20: 'fcb_tutorials_21_Game_Summary@2x.webp',
  };

  public quickTutorialContent: Object = {
    TN_image_0: '',
    TN_image_1: '20-Quickstart.webp',
    TN_image_2: '03-1-Scores.webp',
    TN_image_3: '03-2-Ways-to-Win.webp',
    TN_image_4: '21-More-Ways-to-Play.webp',
    TN_image_5: '22-Simple-Rules.webp',
  };

  public quickTutorialText: Object = {
    TN_image_0: 'welcome.webp',
    TN_image_1: 'main-bets.webp',
    TN_image_2: 'main-bets.webp',
    TN_image_3: 'main-bets.webp',
    TN_image_4: 'side-bets.webp',
    TN_image_5: 'side-bets.webp',
    TN_image_6: 'side-bets.webp',
    TN_image_7: 'side-bets.webp',
    TN_image_8: 'place-your-bets.webp',
    TN_image_9: 'changing-chips.webp',
    TN_image_10: 'settings.webp',
    TN_image_11: 'deal-a-game.webp',
    TN_image_12: 'live-in-game.webp',
    TN_image_13: 'complete-step.webp',
    TN_image_14: 'side-bet-tut.webp',
    TN_image_15: 'mini-road-map.webp',
    TN_image_16: 'expand-mini-map.webp',
    TN_image_17: 'quick-keys.webp',
    TN_image_18: 'complete-set.webp',
  };
  _subscriptionScale;

  version = '';
  constructor(
    public translate: TranslateService,
    public _utilService: UtilService,
    public firebaseAnalyticsServices: FirebaseAnalyticsService
  ) {
    this._subscriptionScale = _utilService.scaleChange.subscribe((value) => {
      // console.log('_subscriptionScale');
      // console.log(value);
      this.scaleR = value;
    });
    this.version = PageConstant.VERSION;
  }

  ngOnInit(): void {
    this._utilService.loadfcbTutorialManifest();
  }
  ngOnChanges(data) {
    if (data.overlayTutorialScreenDisplay) {
      let display: number = data.overlayTutorialScreenDisplay.currentValue;
      if (display == 0) {
        this.buttonClick('close');
      }
    }

    if (data.isTutorialForHint) {
      if (data.isTutorialForHint.currentValue) {
        this.isTutorialForHint = data.isTutorialForHint.currentValue;
        this.updateTutorialForHint();
      }
    }
    if (data.tutorialCount) {
      if (data.tutorialCount.currentValue) {
        //console.log(("tutorialCount ::: "+JSON.stringify(data)));
        this.tutorialClick(data.tutorialCount.currentValue);
      }
    }
  }

  ngAfterViewInit() {}

  updateTutorialForHint() {
    this.tutorialClick(
      this.tutorialListForHint.length > 0 ? this.tutorialListForHint[0] : 0
    );
  }

  hideTutorials() {
    this.display = 0;
    this.isLangShow = false;
    this.tutorialCount = 0;
    this.modeClicked.emit({ name: 'close' });
  }

  tutorialClick(value) {
    this.tutorialCount = value;
    if (FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount]) {
      this.firebaseAnalyticsServices.sendAction(
        FirebaseConstant.Tutorials_FCB[this.tutorialCount].eventAction,
        FirebaseConstant.Tutorials_FCB[this.tutorialCount].category,
        FirebaseConstant.Tutorials_FCB[this.tutorialCount].Label,
        FirebaseConstant.Tutorials_FCB[this.tutorialCount].catId,
        FirebaseConstant.Tutorials_FCB[this.tutorialCount].eventId
      );
    }
  }

  quickTutorialClick(value) {
    this.quickTutorialCount = value;
  }

  buttonClick(value) {
    //console.log("buttonClick : "+value+' len : '+Object.keys(this.tutorialContent).length+" tutorialCount : "+this.tutorialCount);
    let contentObj: Object;
    if (this.isShowTutorial == 'true') {
      contentObj = this.quickTutorialContent;
    } else {
      contentObj = this.tutorialContent;
    }
    switch (value) {
      case 'left':
        if (this.isTutorialForHint) {
          if (this.tutorialListForHint.indexOf(this.tutorialCount) > 0) {
            this.tutorialCount =
              this.tutorialListForHint[
                this.tutorialListForHint.indexOf(this.tutorialCount) - 1
              ];
          } else {
            this.showTutorialHome();
          }
        } else {
          this.tutorialCount > 0
            ? this.tutorialCount--
            : (this.tutorialCount = Object.keys(contentObj).length - 1);
          if (FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount]) {
            this.firebaseAnalyticsServices.sendAction(
              FirebaseConstant.Tutorials_FCB[this.tutorialCount].eventAction,
              FirebaseConstant.Tutorials_FCB[this.tutorialCount].category,
              FirebaseConstant.Tutorials_FCB[this.tutorialCount].Label,
              FirebaseConstant.Tutorials_FCB[this.tutorialCount].catId,
              FirebaseConstant.Tutorials_FCB[this.tutorialCount].eventId
            );
          }
        }
        break;
      case 'right':
        if (this.isShowTutorial == 'true') {
          //console.log("===isShowTutorial===inn====000========");
          if (this.tutorialCount < Object.keys(contentObj).length - 1) {
            this.tutorialCount++;
          } else {
            this.isShowQuickTutorial = true;
            this.showQuickTutorial.emit(true);
            this.display = 3;
            this.modeClicked.emit({ name: 'close' });
            //this.tutorialCount  = 0;
          }
        } else {
          //console.log("===isShowTutorial===inn====1111========");
          if (this.isTutorialForHint) {
            if (
              this.tutorialListForHint.indexOf(this.tutorialCount) <
              this.tutorialListForHint.length - 2
            ) {
              this.tutorialCount =
                this.tutorialListForHint[
                  this.tutorialListForHint.indexOf(this.tutorialCount) + 1
                ];
            } else {
              this.showTutorialHome();
            }
          } else {
            this.tutorialCount < Object.keys(contentObj).length - 1
              ? this.tutorialCount++
              : (this.tutorialCount = 0);
            if (FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount]) {
              this.firebaseAnalyticsServices.sendAction(
                FirebaseConstant.Tutorials_FCB[this.tutorialCount].eventAction,
                FirebaseConstant.Tutorials_FCB[this.tutorialCount].category,
                FirebaseConstant.Tutorials_FCB[this.tutorialCount].Label,
                FirebaseConstant.Tutorials_FCB[this.tutorialCount].catId,
                FirebaseConstant.Tutorials_FCB[this.tutorialCount].eventId
              );
            }
          }
        }

        break;
      case 'home':
        this.showTutorialHome();
        break;
      case 'close':
        this.hideTutorials();
        break;
      default:
        break;
    }
    //console.log("this.soundvolume : "+this.soundvolume+"this.tutorialCount : "+this.tutorialCount+" name : "+contentObj['TN_image_'+this.tutorialCount]);
  }

  showTutorialHome() {
    this.isTutorialForHint = false;
    this.display = 1;
    this.tutorialCount = 0;
    if (FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount]) {
      this.firebaseAnalyticsServices.sendAction(
        FirebaseConstant.Tutorials_FCB[this.tutorialCount].eventAction,
        FirebaseConstant.Tutorials_FCB[this.tutorialCount].category,
        FirebaseConstant.Tutorials_FCB[this.tutorialCount].Label,
        FirebaseConstant.Tutorials_FCB[this.tutorialCount].catId,
        FirebaseConstant.Tutorials_FCB[this.tutorialCount].eventId
      );
    }
  }

  nextPrevButtonClick(value) {
    let contentObj: Object = this.quickTutorialText;
    switch (value) {
      case 'next':
        this.quickTutorialCount < Object.keys(contentObj).length - 1
          ? this.quickTutorialCount++
          : this.hideQuickTutorials();
        break;
      case 'prev':
        this.quickTutorialCount > 0
          ? this.quickTutorialCount--
          : (this.quickTutorialCount = Object.keys(contentObj).length - 1);
        break;
    }
  }

  hideQuickTutorials = () => {
    this.isShowQuickTutorial = false;
    this.isShowTutorial = 'false';
    this.display = 0;
    this.isLangShow = false;
    this.tutorialCount = 0;
    this.hideTutorials();
  };

  ngOnDestory() {
    if (this._subscriptionScale) {
      this._subscriptionScale.unsubscribe();
    }
    delete this._subscriptionScale;
  }
}
